import clsx from 'clsx';
import React from 'react';
import { Container } from 'react-bootstrap';

import { CONTACT_FORM_URL, MEDIA_KIT_URL, PARTNERSHIP_IMAGE_URL } from '../../utils/constants';
import { Button } from '../BaseUI';
import styles from './styles.module.css';

const PartnershipOpportunitiesSection = () => {
  return (
    <div className={styles.partnershipBackground}>
      <Container>
        <div className={styles.partnershipContainer}>
          <h5 className={styles.partnershipTitle}>Partnership Opportunities</h5>
          <h1 className={styles.partnershipSubTitle}>Why The Information</h1>
          <p className={styles.partnershipContent}>
            The Information is the most trusted outlet covering technology and all it transforms,
            with a nearly decade-long track record of breaking the biggest news and trends first.
            Led by reporter and editor Jessica Lessin, The Information’s newsrooms consist of the
            highest caliber journalists committed to driving and owning the biggest stories of the
            moment—often years before other outlets catch on. The Information—which publishes new
            articles, newsletters and data projects directly into subscribers’ inboxes daily—has
            earned it a slew of journalism awards and an elite and engaged audience of hundreds of
            thousands of professionals from around the world.
          </p>
          <div className={styles.buttonWrap}>
            <Button
              href={CONTACT_FORM_URL}
              className={clsx(styles.button, styles.blackButton)}
              rounded="slight"
              trackClick
              trackingProps={{
                name: 'partnership_contact_form',
                location: 'partnership_opportunities',
              }}
            >
              GET IN CONTACT
            </Button>
            <Button
              href={MEDIA_KIT_URL}
              trackClick
              trackingProps={{
                name: 'media_kit',
                location: 'partnership_opportunities',
              }}
              variant="link"
            >
              VIEW MEDIA KIT
            </Button>
          </div>
        </div>
        <img src={PARTNERSHIP_IMAGE_URL} className={styles.partnershipImage} />
      </Container>
    </div>
  );
};
export default PartnershipOpportunitiesSection;
